<div class="card">
  <div class="card-head d-flex justify-content-between align-items-center">
    <span class="card-head-text h5">What to learn next</span>
    <button class="view-button h5" (click)="goToAllNextLearnings()">View all <i
        class="fa fa-angle-double-right"></i></button>
  </div>
  <hr>
  <div class="card-content p-2">
    <ng-container *ngFor="let nextlearning of nextLearnings; let i = index ">
      <div class="d-flex pb-2 pt-2 nextlearning-container" (click)="goToPrograms(nextlearning)">
        <div class="next-image-container col-2 ml-2">
          <img class="next-image" src="../../../../assets/images/employeeCareer/cloud.png">
        </div>
        <div class="col-10 d-flex flex-column justify-content-center">
          <span class="next-learning-text h5">{{nextlearning.programName}}</span>
          <!-- <br>
                          <span>{{nextlearning.programDescription}}</span> -->
        </div>
      </div>
      <hr *ngIf="i < nextLearnings?.length - 1" class="transparent-hr">
    </ng-container>
  </div>
</div>